import { Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { ContestSettingsStore } from './shared/stores/contest-settings.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxSpinnerComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly titleService = inject(Title);
  private readonly contestSettingsStore = inject(ContestSettingsStore);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.contestSettingsStore.contestSettings$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(s => {
      if (s) {
        this.titleService.setTitle(`Voting AWA ${s.year || new Date().getFullYear()}`);
      }
    });
  }
}
